import Vue from "vue";

export async function list() {
  const response = await Vue.prototype.$http.get("/form-templates");
  return response.data;
}

export async function store(payload) {
  const response = await Vue.prototype.$http.post("/form-templates", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
}

export async function update(id, payload) {
  payload.append("_method", "PUT");

  const response = await Vue.prototype.$http.post(
    `/form-templates/${id}`,
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
}

export async function remove(id) {
  const response = await Vue.prototype.$http.delete(`/form-templates/${id}`);

  return response.data;
}

export async function upload(id, formData) {
  const response = await Vue.prototype.$http.post(
    `/form-templates/${id}/file`,
    formData
  );

  return response.data;
}

export async function indexBySubtype(subtypeId) {
  const response = await Vue.prototype.$http.get(
    `/form-templates/subtypes/${subtypeId}`
  );

  return response.data;
}

export async function showGlossary() {
  const response = await Vue.prototype.$http.get(`/form-templates/glossary`);

  return response.data.data;
}
